import { Pill } from '@hub/pill'
import { Stack } from '@hub/stack'
import { getAbsolutePathFromRouter } from '@scentregroup/shared/helpers/url-helpers'
import React from 'react'
import { useRouter } from '@scentregroup/shared/next/router'

import { StoresBreadcrumbPath } from './types'

type PillsProps = {
  path: StoresBreadcrumbPath
}

export const Pills: React.FC<PillsProps> = ({ path }) => {
  const router = useRouter()

  const handleClosePath = (item: (typeof path)[0]): void => {
    const i = path.findIndex(a => a === item)
    if (i < 0) {
      return
    }
    router.push(
      getAbsolutePathFromRouter(router, {
        categories: path.slice(0, i).map(({ slug }) => slug),
        page: undefined,
      })
    )
  }

  const pills = path.map(item => ({
    key: item.slug,
    title: item.title,
    onClose: () => handleClosePath(item),
    ariaLabel: `Remove '${item.title}' filtering`,
  }))

  if (pills.length === 0) {
    return null
  }

  return (
    <Stack
      direction="row"
      sx={{
        marginBottom: 'spacing-lg',
        flexWrap: 'wrap',
        rowGap: 'spacing-xs',
        columnGap: 'spacing-sm',
        alignContent: 'flex-start',
      }}
      shouldWrapChildren={false}
    >
      {pills.map(({ title, key, ...props }, index) => (
        <Pill
          key={key || index}
          colorScheme="surfacePrimary"
          variant="full"
          flexGrow={0}
          {...props}
        >
          {title}
        </Pill>
      ))}
    </Stack>
  )
}
